import { useEffect, useState } from 'react';
import { Button } from '../../../../components/form/button';
import { Typography } from '../../../../components/typography/typography';
import { Field } from '../../../../components/field/field';
import { Tooltip } from '../../../../components/tooltip/tooltip';
import Icon from '../../../../components/icons/icon';
import { toast } from '../../../../util/toasts';
import { useAPI } from '../../../../clients/quipli-service/quipli-service-client';
import { AliasType } from '../../../../clients/quipli-service/alias/alias';

export const AliasesField = ({
  name,
  initialAliases,
  inputId,
  aliasType,
}: {
  name: string;
  initialAliases: string;
  inputId: string;
  aliasType: AliasType;
}) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [aliasesInput, setAliasesInput] = useState<string>(name);
  const [aliases, setAliases] = useState<string>(initialAliases);
  const { generateCategoryAiAliases, generateProductAiAliases } = useAPI();
  const generateAliases = async () => {
    try {
      setIsLoading(true);
      let generatedAliases: string[];

      if (aliasType === AliasType.Category) {
        generatedAliases = await generateCategoryAiAliases(aliasesInput);
      } else {
        generatedAliases = await generateProductAiAliases(aliasesInput);
      }

      setAliases(generatedAliases.join(', '));
    } catch (e) {
      toast('Something went wrong while generating aliases', 'error');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (aliases) $(`#${inputId}`).val(aliases);
  }, [aliases]);

  return (
    <div className="">
      <Field type="text" value={aliases} onChange={(v) => setAliases(v)} />
      <div className="mt-2">
        <Typography type="text-md" weight="bold">
          Feeling stuck coming up with other names? Let AI write it!
        </Typography>
        <div className="flex mt-4 gap-8 items-center">
          <div className="flex gap-4">
            <div className="flex gap-1 items-center">
              <Typography type="text-xs" weight="medium">
                AI Input
              </Typography>
              <Tooltip tooltip="Enter the word you want AI to use to generate aliases">
                <Icon icon="InfoCircle" />
              </Tooltip>
            </div>
            <Field className="w-full" type="text" value={aliasesInput} onChange={(v) => setAliasesInput(v)} />
          </div>
          <Button disabled={!aliasesInput || isLoading} onClick={generateAliases} className="h-[40px] button-primary">
            Generate Aliases with AI
          </Button>
        </div>
      </div>
    </div>
  );
};
